/**
 * announcement-delivery-countdown.js  (v3 — fix timing de geolocalización tardía)
 * Integra coverage-gam.js con el primer slide del announcement_bar_slider.
 *
 * Opción A: reescribe el contenido del PRIMER mensaje del slider segun la
 * cobertura same-day geolocalizada del visitante. Si no hay ubicacion
 * (estado 'generico'), NO toca el slide: queda el mensaje configurado en el theme editor.
 *
 * Requiere que coverage-gam.js y pickup-countdown-cr.js se carguen ANTES que este archivo.
 *
 * CAMBIOS v4 (BOPIS 30 min, etapa 2):
 *   - El sufijo de retiro nombra la tienda (la elegida o la más cercana por GPS)
 *     y, cuando la entrega a domicilio ya no es HOY, lleva su propio countdown
 *     hasta el corte de esa tienda (cierre - 30 min). Un countdown a la vez.
 *   - Un solo timer para los dos countdowns; recompone el copy en cualquier cruce.
 *   - Los listeners se registraban solo si el slide no existía al arrancar.
 *   - Pasado el corte de la tienda, si otra cercana sigue abierta, el retiro
 *     cuenta hasta el corte de esa (txtRetiroAlternativa / txtRetiroAlternativaUrgente).
 *
 * CAMBIOS v3:
 *   - Fix race condition: en sesiones nuevas, el prompt de geolocalización del
 *     navegador es asíncrono. my-store-locator.js escribe la cookie
 *     'location_position' recién cuando el usuario ACEPTA, lo que ocurre DESPUÉS
 *     del primer aplicar(). Antes el slide quedaba en el mensaje genérico para
 *     siempre. Ahora, si el estado inicial es 'generico', se hace un polling
 *     corto vigilando la aparición de la cookie y se re-aplica al detectarla.
 *     También escucha un evento opcional 'ishop:location-ready' por si el
 *     locator lo emite en el futuro (red de seguridad de cero costo).
 *   - Detección de cruce de umbral por estado interno (data-delivery-mode) en
 *     vez de inspeccionar el texto, robusta ante cambios de copy.
 *
 * Configuración (opcional) vía window.ANNOUNCEMENT_CONFIG:
 *   - umbralCountdownHoras, umbralUltimaHoraHoras
 *   - txtBeneficioHoy, txtCountdown, txtCountdownUrgente, txtManana, txtFuera, txtRetiro
 * Si no hay config, se usan los defaults históricos.
 *
 * Matriz de mensajes (cobertura x tiempo):
 *   en zona, faltan > umbral        -> beneficio sin numeros
 *   en zona, faltan <= umbral y > 1h-> countdown "Quedan Xh Ym para recibirlo hoy"
 *   en zona, ultima hora (<= 1h)    -> countdown con copy mas urgente
 *   en zona, pasado corte/dom/fer   -> "Recibilo MANANA en tu zona"
 *   fuera de zona                   -> "Entrega a domicilio en 2 dias habiles"
 *   sin ubicacion                   -> no se modifica
 */
(function () {
  'use strict';

  var CFG = window.ANNOUNCEMENT_CONFIG || {};

  function num(v, def) {
    var n = parseFloat(v);
    return isFinite(n) ? n : def;
  }
  function txt(v, def) {
    return (typeof v === 'string' && v.length) ? v : def;
  }
  // El admin recorta el espacio inicial al guardar (" · Retiro" queda "· Retiro"
  // y la barra pegaba "GAM*· Retiro"): los sufijos se normalizan aquí.
  function sufijo(v, def) {
    return ' ' + txt(v, def).replace(/^\s+/, '');
  }

  // Umbrales en segundos (config en horas, fallback 4h / 1h).
  var UMBRAL_COUNTDOWN   = num(CFG.umbralCountdownHoras, 4) * 3600;
  var UMBRAL_ULTIMA_HORA = num(CFG.umbralUltimaHoraHoras, 1) * 3600;

  // Días hábiles fuera de zona (para el placeholder {numero_de_dias} del texto).
  var DIAS_FUERA = num(CFG.diasEntregaFuera, 2);

  var TXT = {
    beneficioHoy:     txt(CFG.txtBeneficioHoy,     'Recibilo HOY si comprás antes de las {hora}'),
    countdown:        txt(CFG.txtCountdown,        'Quedan {cd} para recibirlo HOY'),
    countdownUrgente: txt(CFG.txtCountdownUrgente, 'Últimos {cd} para recibirlo HOY'),
    manana:           txt(CFG.txtManana,           'Recibilo {label} en tu zona de cobertura'),
    fuera:            txt(CFG.txtFuera,            'Entrega a domicilio en 2 días hábiles'),
    retiro:           sufijo(CFG.txtRetiro,           ' · Retiro en tienda en 30 min'),
    retiroTienda:     sufijo(CFG.txtRetiroTienda,     ' · Retiro en {tienda} en 30 min'),
    retiroCountdown:  sufijo(CFG.txtRetiroCountdown,  ' · Recogé HOY en {tienda}: quedan {cd}'),
    retiroUrgente:    sufijo(CFG.txtRetiroUrgente,    ' · Recogé HOY en {tienda}: últimos {cd}'),
    retiroProximo:    sufijo(CFG.txtRetiroProximo,    ' · Retiro en {tienda} {label} desde las {hora}'),
    retiroAlternativa: sufijo(CFG.txtRetiroAlternativa, ' · Aún podés recoger HOY en {tienda}: quedan {cd}'),
    retiroAlternativaUrgente: sufijo(CFG.txtRetiroAlternativaUrgente, ' · Aún podés recoger HOY en {tienda}: últimos {cd}')
  };

  var SLIDE_SEL = '#shopify-section-announcement_bar_slider .hura-message';
  var MARK = 'data-delivery-dynamic';
  var MODE = 'data-delivery-mode';   // 'beneficio' | 'countdown' | 'urgente' | 'manana' | 'fuera'

  function fmtHora(h) {
    var ampm = h >= 12 ? 'pm' : 'am';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + ':00' + ampm;
  }

  // Segundos del día -> "10:00am", "9:30pm".
  function fmtHoraSeg(seg) {
    var h = Math.floor(seg / 3600), m = Math.floor((seg % 3600) / 60);
    var ampm = h >= 12 ? 'pm' : 'am';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + ':' + (m < 10 ? '0' : '') + m + ampm;
  }

  function fmtCountdown(segs) {
    if (segs < 0) segs = 0;
    var h = Math.floor(segs / 3600);
    var m = Math.floor((segs % 3600) / 60);
    var s = segs % 60;
    if (h > 0) return h + 'h ' + (m < 10 ? '0' : '') + m + 'm';
    if (m > 0) return m + 'm ' + (s < 10 ? '0' : '') + s + 's';
    return s + 's';
  }

  // Devuelve { html, mode } para poder guardar el modo sin parsear el texto.
  function construir(d) {
    if (d.estado === 'hoy') {
      if (d.segundosRestantes > UMBRAL_COUNTDOWN) {
        return { html: TXT.beneficioHoy.replace('{hora}', fmtHora(d.corteHora)), mode: 'beneficio' };
      }
      var urgente = d.segundosRestantes <= UMBRAL_ULTIMA_HORA;
      var plantilla = urgente ? TXT.countdownUrgente : TXT.countdown;
      return {
        html: plantilla.replace('{cd}', '<span class="js-delivery-cd">' + fmtCountdown(d.segundosRestantes) + '</span>'),
        mode: urgente ? 'urgente' : 'countdown'
      };
    }
    if (d.estado === 'manana') {
      return { html: TXT.manana.replace('{label}', '<strong>' + (d.label || 'MAÑANA') + '</strong>'), mode: 'manana' };
    }
    if (d.estado === 'fuera') {
      return { html: TXT.fuera.replace('{numero_de_dias}', DIAS_FUERA), mode: 'fuera' };
    }
    return null;
  }

  // Sufijo de retiro en tienda. Un solo countdown a la vez: si la entrega a
  // domicilio ya muestra el suyo, el retiro va fijo con el nombre de la tienda.
  // Fuera de eso (beneficio de la mañana, noche, domingo, fuera del GAM) el
  // retiro lleva su propio countdown hasta el corte de esa tienda.
  function sufijoRetiro(modoEntrega) {
    var p = window.iShopPickup && window.iShopPickup.detalle();
    if (!p) return { html: TXT.retiro, mode: 'fijo' };
    var nombre = p.tienda.nombre;
    // La tienda ya cortó, pero una vecina sigue recibiendo retiros hoy.
    if (p.estado === 'cerrada' && p.alternativa) {
      var a = p.alternativa;
      var plantillaAlt = a.estado === 'urgente' ? TXT.retiroAlternativaUrgente : TXT.retiroAlternativa;
      return {
        html: plantillaAlt.replace('{tienda}', a.tienda.nombre)
          .replace('{cd}', '<span class="js-pickup-cd">' + fmtCountdown(a.segundosRestantes) + '</span>'),
        mode: 'alt:' + a.tienda.id + ':' + a.estado,
        segundos: a.segundosRestantes
      };
    }
    var entregaCd = modoEntrega === 'countdown' || modoEntrega === 'urgente';
    // Con entrega HOY el mensaje principal ya es largo: el retiro va fijo.
    var entregaHoy = entregaCd || modoEntrega === 'beneficio';

    if (entregaHoy && p.estado !== 'cerrada') {
      return { html: TXT.retiroTienda.replace('{tienda}', nombre), mode: 'tienda' };
    }
    if (p.estado === 'abre' || p.estado === 'cerrada') {
      return {
        html: TXT.retiroProximo.replace('{tienda}', nombre)
          .replace('{label}', '<strong>' + p.label + '</strong>')
          .replace('{hora}', fmtHoraSeg(p.hora)),
        mode: p.estado + ':' + p.label
      };
    }
    if (p.estado === 'abierta') {
      return { html: TXT.retiroTienda.replace('{tienda}', nombre), mode: 'tienda' };
    }
    var plantilla = p.estado === 'urgente' ? TXT.retiroUrgente : TXT.retiroCountdown;
    return {
      html: plantilla.replace('{tienda}', nombre)
        .replace('{cd}', '<span class="js-pickup-cd">' + fmtCountdown(p.segundosRestantes) + '</span>'),
      mode: p.estado,
      segundos: p.segundosRestantes
    };
  }

  // Estado completo del slide: { html, mode, entregaSeg, retiroSeg }.
  // mode combina los dos ("manana|countdown") para detectar cualquier cruce.
  function componer() {
    var d = window.iShopCoverage.detalle();
    var built = construir(d);
    if (built === null) return null;
    var suf = sufijoRetiro(built.mode);
    var cdEntrega = built.mode === 'countdown' || built.mode === 'urgente';
    return {
      html: built.html + suf.html,
      mode: built.mode + '|' + suf.mode,
      entregaSeg: cdEntrega ? d.segundosRestantes : null,
      retiroSeg: suf.segundos != null ? suf.segundos : null
    };
  }

  var cdTimer = null;

  function aplicar(slide) {
    if (!window.iShopCoverage) return;
    var c = componer();

    if (cdTimer) { clearInterval(cdTimer); cdTimer = null; }

    // Estado 'generico' (sin ubicación): restaurar el original si lo habíamos tocado.
    if (c === null) {
      if (slide.getAttribute(MARK) === '1' && slide._origHTML != null) {
        slide.innerHTML = slide._origHTML;
        slide.removeAttribute(MARK);
        slide.removeAttribute(MODE);
      }
      return;
    }

    if (slide._origHTML == null) slide._origHTML = slide.innerHTML;
    slide.innerHTML = c.html;
    slide.setAttribute(MARK, '1');
    slide.setAttribute(MODE, c.mode);

    // Con un countdown visible se refresca cada segundo; sin él, cada 30 s
    // basta para pasar de tramo (abre -> abierta -> countdown, corte -> mañana).
    var visible = c.entregaSeg != null || c.retiroSeg != null;
    cdTimer = setInterval(function () {
      var n = componer();
      // Cualquier cruce de tramo, de la entrega o del retiro: recomponer el copy.
      if (n === null || n.mode !== slide.getAttribute(MODE)) {
        aplicar(slide);
        return;
      }
      var cd = slide.querySelector('.js-delivery-cd');
      if (cd && n.entregaSeg != null) cd.textContent = fmtCountdown(n.entregaSeg);
      var pcd = slide.querySelector('.js-pickup-cd');
      if (pcd && n.retiroSeg != null) pcd.textContent = fmtCountdown(n.retiroSeg);
    }, visible ? 1000 : 30000);
  }

  // --------------------------------------------------------------------------
  // Fix timing: vigilar la aparición tardía de la ubicación.
  // El prompt de geolocalización es asíncrono; la cookie 'location_position'
  // (o un preferredStoreId) puede aparecer DESPUÉS del primer aplicar().
  // --------------------------------------------------------------------------
  function hayUbicacion() {
    try {
      if (window.localStorage && localStorage.getItem('preferredStoreId')) return true;
    } catch (e) {}
    return document.cookie.indexOf('location_position=') !== -1;
  }

  function vigilarUbicacion(slide) {
    // Si ya hay ubicación, no hace falta vigilar (el aplicar() inicial ya la usó).
    if (hayUbicacion()) return;

    var intentos = 0;
    var MAX_INTENTOS = 24;          // 24 * 500ms = 12s, cubre el tiempo de decisión del prompt
    var iv = setInterval(function () {
      intentos++;
      if (hayUbicacion()) {
        clearInterval(iv);
        aplicar(slide);             // la ubicación llegó: reescribir el slide
      } else if (intentos >= MAX_INTENTOS) {
        clearInterval(iv);          // el usuario no aceptó / no hay GPS: queda el genérico
      }
    }, 500);

    // El locator emite este evento al aceptar el prompt: dejamos de pollear.
    document.addEventListener('ishop:location-ready', function onReady() {
      clearInterval(iv);
      document.removeEventListener('ishop:location-ready', onReady);
    });
  }

  function init() {
    var slide = document.querySelector(SLIDE_SEL);
    if (!slide) return false;
    aplicar(slide);
    vigilarUbicacion(slide);        // <-- clave del fix
    return true;
  }

  function start() {
    // Los listeners van antes del init: con el slide ya en el DOM, init() da true
    // al primer intento y el return de abajo los dejaba sin registrar.

    // my-store-locator.js lo emite al aceptar el prompt de ubicación y al elegir
    // tienda a mano.
    document.addEventListener('ishop:location-ready', function () {
      var s = document.querySelector(SLIDE_SEL);
      if (s) aplicar(s);
    });

    // Reaccionar a la selección manual de tienda (intención explícita del usuario).
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.js-make-my-store-btn, .js-store-locator-select-btn')) {
        setTimeout(function () {
          var s = document.querySelector(SLIDE_SEL);
          if (s) aplicar(s);
        }, 600);
      }
    });

    if (init()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (init() || tries > 40) clearInterval(iv);
    }, 250);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();